import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useConfirm } from '../../../../shared/components/confirm/ConfirmProvider'
import { validateRestrictions } from '../../transit-operation/api/validateRestrictions'
import RestrictionWarningMessage, { hasRestrictionHits } from './RestrictionWarningMessage'

function useRestrictionWarning() {
  const { t } = useTranslation()
  const { confirm } = useConfirm()

  const confirmRestrictionWarning = useCallback(async (transitOperationId: number): Promise<boolean> => {
    const check = await validateRestrictions(transitOperationId)
    if (!hasRestrictionHits(check)) {
      return true
    }

    return confirm({
      title: t('transitOperation.restrictionWarning.title'),
      message: <RestrictionWarningMessage check={check} />,
      confirmText: t('transitOperation.restrictionWarning.confirm'),
      danger: true,
      confirmOnEnter: false,
    })
  }, [confirm, t])

  return { confirmRestrictionWarning }
}

export default useRestrictionWarning
